import Reflux from 'reflux';
import EventFileSystemObjectData from 'shared/data/EventFileSystemObject';

let async = { asyncResult: true },
  EventFolderFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    create: async,
  });

EventFolderFormActions.create.listenAndPromise(
  EventFileSystemObjectData.createFolder,
);

export default EventFolderFormActions;
